import { VLActionModal } from "views/uikit/VLModal";
import { Form } from "antd";
import { useUserModalActions } from "./useUserModals";
import { FormValues, UserForm } from "./userForm";
import styles from "./style.module.scss";

interface CreateUserModalProps {
  isOpen: boolean;
  close: () => void;
  onRefresh?: () => void;
  initialValues?: Partial<FormValues>;
}
const FORM_ID = "create-user-form";

export const CreateUserModal = ({
  isOpen,
  close,
  onRefresh,
  initialValues = {},
}: CreateUserModalProps) => {
  const [form] = Form.useForm<FormValues>();
  const { createUser, loading } = useUserModalActions({
    onRefresh,
  });

  const handleClose = () => {
    form.resetFields();
    close();
  };

  const handleSubmit = async (values: FormValues) => {
    try {
      await createUser({
        username: values.username,
        firstName: values.firstName,
        lastName: values.lastName,
        password: values.password,
        workspace_role: values.role.toLowerCase() as
          | "admin"
          | "editor"
          | "viewer",
      });

      form.resetFields();
      close();
    } catch (err) {
      console.error("Error creating user:", err);
    }
  };

  return (
    <VLActionModal
      isOpen={isOpen}
      variant="general"
      onClose={handleClose}
      htmlType="submit"
      form={FORM_ID}
      headers={{
        title: "Create New User",
      }}
      actionLabel="Save"
      loading={loading}
      showCancel
      cancelBtnClassName={styles.cancelbutton}
    >
      <UserForm
        form={form}
        initialValues={initialValues}
        onFinish={handleSubmit}
        loading={loading}
      />
    </VLActionModal>
  );
};
